export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.multiple,
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: !that.multiple,
  },
  {
    title: that.$l('table_choose_label_displayImage') || '图片',
    field: 'displayImage',
    width: 80,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_choose_label_displayName') || '产品名称',
    field: 'displayName',
    minWidth: 240,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_choose_label_displayBrand') || '产品品牌',
    field: 'displayBrand',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayBrand' },
  },
  {
    title: that.$l('table_choose_label_custName') || '客户名称',
    field: 'custName',
    minWidth: 240,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_choose_label_displayCreate') || '创建人',
    field: 'displayCreate',
    align: 'left',
    width: 170,
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_choose_label_displayModify') || '修改人',
    field: 'displayModify',
    align: 'left',
    width: 170,
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
